import '../../style/index.less';
import '../../layout/style/index.less';



/** WEBPACK FOOTER **
 ** ./components/col/style/index.js
 **/